import React, { useState } from 'react';
import {
  Button,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';
import VersionModal from './VersionModal';

const useStyles = makeStyles((theme) => ({
  versionButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
    },
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
}));

const VersionButton = ({ version = 'v2.6' }) => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Tooltip title="Ver atualizações do dia">
        <Button
          className={classes.versionButton}
          startIcon={<InfoIcon className={classes.icon} />}
          onClick={() => setOpenModal(true)}
          size="small"
        >
          {version}
        </Button>
      </Tooltip>

      <VersionModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        version={version}
      />
    </>
  );
};

export default VersionButton;
